import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography,
  Accordion, AccordionDetails, AccordionSummary,
} from '@mui/material';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { vialAccordionStyles } from './PlugStyles';
import VialGreenIcon from '../Assets/vial-green-icon.svg';
import VialSummaryCard from './VialSummaryCard';

const VialAccordion = ({
  panel, setPanel, vials, id,
}) => (
  <Accordion
    sx={panel === `${id}` ? vialAccordionStyles.AccordionExpanded : vialAccordionStyles.Accordion}
    elevation={0}
    expanded={panel === `${id}`}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreRoundedIcon sx={vialAccordionStyles.ArrowIcon} />}
      sx={vialAccordionStyles.AccordionSummary}
      onClick={() => {
        if (panel !== `${id}`) {
          setPanel(`${id}`);
        } else {
          setPanel('');
        }
      }}
    >
      <Box>
        <Box sx={vialAccordionStyles.AccordionSummaryBox}>
          <img src={VialGreenIcon} alt="profile" width={32} height={32} />
          <Typography
            sx={vialAccordionStyles.SetNumber}
          >
            Vials reported ({vials.length}/{vials.length})
          </Typography>
        </Box>
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={vialAccordionStyles.AccordionDetails}>
      {
        vials.map((vial, i) => (
          <>
            <VialSummaryCard vialData={vial} iteration={i} key={vial?.barcode} />
            {vials.length - 1 !== i && <Box sx={vialAccordionStyles.Divider} />}
          </>
        ))
      }
    </AccordionDetails>
  </Accordion>
);

VialAccordion.propTypes = {
  vials: PropTypes.any,
  panel: PropTypes.string,
  setPanel: PropTypes.func,
  id: PropTypes.number,
};

export default VialAccordion;
